import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as allActions from "./actions";

/**
 * Hook providing bound action creators for the updateEngine Redux slice.
 * @returns {Object} Bound action creators: updateUpdateEngine, updateUpdateEngineSearchForm, clearUpdateEngine, clearJobViewModal
 */
export function useUpdateEngineActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
